import React from 'react';
import LitImage from './images/LitImage';
import { ContactUsFormSubmitted } from '../data/Cookies';
import { Cookies } from 'react-cookie-consent';

const HumanHelpSubmitted = ({ formSubmittedImage, setFormSubmitted }) => {
  return (
    <div className="form-wrapper Centre" style={{ width: '100%' }}>
      <div className="form White" style={{ width: '100%' }}>
        <div className="form-submitted">
          <div className="form-submitted-image">
            <LitImage image={formSubmittedImage} alt="Icon" />
          </div>
          <h5>Great, your enquiry has been sent!</h5>
          <p>We will be in touch very soon.</p>
          <p style={{ paddingTop: '1em' }}>
            Call backs will only happen during our office hours of Mon-Fri,
            9:00-5:30pm.
          </p>
        </div>{' '}
        <button
          onClick={() => {
            Cookies.remove(ContactUsFormSubmitted);
            setFormSubmitted(false);
          }}
          className="button"
          type="button"
        >
          Submit another query
        </button>
      </div>
    </div>
  );
};

export default HumanHelpSubmitted;
